import { render, staticRenderFns } from "./transferenciasPremiosImputacionesFiltro.vue?vue&type=template&id=2df0d1fa&"
import script from "./transferenciasPremiosImputacionesFiltro.vue?vue&type=script&lang=js&"
export * from "./transferenciasPremiosImputacionesFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports